// extracted by mini-css-extract-plugin
module.exports = {"langListBlock":"language-list-overlay-module--lang-list-block--2qbDV"};